<template>
  <div class="users-window">
    <h1 class="page-header">Users</h1>
    <div class="table">
      <users-table v-bind:viewPage="'users'"></users-table>
    </div>
    <learner-profile></learner-profile>
  </div>
</template>

<script>
import UsersTable from "@/modules/users/components/UsersTableComponent.vue";
import LearnerProfileLayout from "@/modules/global/layouts/LearnerProfileLayout.vue";
export default {
  name: "Users",

  components: {
    "users-table": UsersTable,
    "learner-profile": LearnerProfileLayout
  }
};
</script>
